var map = {
	"./mi-afspraak-maken.svg": "90d9",
	"./mi-afwezigheid-huisartsen.svg": "0842",
	"./mi-compliment-geven.svg": "6394",
	"./mi-contact.svg": "e457",
	"./mi-herhaal-recepten.svg": "1278",
	"./mi-huisbezoek.svg": "c491",
	"./mi-inschrijving.svg": "9f90",
	"./mi-klachtenregeling.svg": "6b98",
	"./mi-lab.svg": "6661",
	"./mi-links.svg": "1e10",
	"./mi-moet-ik-naar-de-dokter.svg": "6095",
	"./mi-online-services.svg": "3161",
	"./mi-patientenportaal.svg": "1659",
	"./mi-patienttevredenheidsonderzoek.svg": "d361",
	"./mi-praktijkinfo.svg": "d041",
	"./mi-privacy.svg": "c838",
	"./mi-speciale-onderzoeken.svg": "a36b",
	"./mi-spoed.svg": "5099",
	"./mi-spreekuren.svg": "427f",
	"./mi-team.svg": "1112"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9a2";